<template>
  <div class="disclaimer">
    <p>{{ $_getTranslations.home_store_vat_description_pt1 }}</p>
    <p>{{ $_getTranslations.home_store_vat_description_pt2 }}</p>
  </div>
</template>

<script>
import translationMixin from '../../../../common/mixins/translation'

export default {
  name: 'VatSection',
  mixins: [translationMixin],
}
</script>



// WEBPACK FOOTER //
// src/components/home/store/section/VatSection.vue